import {z} from 'zod';

export const ProgressReportWarningObjectSchema = z.object({});

export const ProgressReportProgressMessageSchema = z.object({
	code: z.number().int().positive(),
	codeLabel: z.string(),
	objectId: z.number().int().positive(),
	objectLabel: z.string(),
	objectType: z.string(),
	taskId: z.number().int().positive(),
	taskName: z.string(),
	taskType: z.string(),
});

export const ProgressReportSchema = z.object({
	percentComplete: z.number().int().positive(),
	percentLastLogged: z.number().int().positive(),
	jobTitle: z.string(),
	secondsToReload: z.number().int().positive(),
	completeUrl: z.string().nullable(),
	details: z.string(),
	increment: z.number().int().positive(),
	startTime: z.number().int().positive(),
	runningTime: z.number().int().positive(),
	runningTimeLabel: z.string().nullable(),
	estimatedTime: z.number().int().positive().nullable(),
	userId: z.number().int().positive(),
	notifyOnComplete: z.boolean(),
	size: z.number().int().positive(),
	progressMessages: z.array(ProgressReportProgressMessageSchema).nullable(),
	progressMessageCount: z.number().int().positive(),
	warningObject: ProgressReportWarningObjectSchema.nullable(),
});

export type IProgressReport = z.infer<typeof ProgressReportSchema>;

export type IProgressReportProgressMessage = z.infer<
	typeof ProgressReportProgressMessageSchema
>;

export type IProgressReportWarningObject = z.infer<
	typeof ProgressReportWarningObjectSchema
>;
